import { FC, useContext } from "react";
import { FormattedMessage } from "react-intl";
import { LocalizationContext } from "~/components/LocalizationWrapper";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "~/components/ui/select";

const languages = [
  { value: "en", labelId: "settings.englishLang", defaultMessage: "English" },
  { value: "fr", labelId: "settings.frenchLang", defaultMessage: "French" },
];

export const SettingsLang: FC = () => {
  const { locale, setLocale } = useContext(LocalizationContext);

  const handleLocaleChange = (locale: string) => {
    setLocale(locale);
  };

  return (
    <div className="w-full flex flex-col gap-2">
      <span className="text-sm font-medium">
        <FormattedMessage id="settings.language" defaultMessage={"Language"} />
      </span>
      <Select defaultValue={locale} onValueChange={handleLocaleChange}>
        <SelectTrigger>
          <SelectValue placeholder="Select a fruit" />
        </SelectTrigger>
        <SelectContent>
          {languages.map(({ value, labelId, defaultMessage }) => (
            <SelectItem key={value} value={value}>
              <FormattedMessage id={labelId} defaultMessage={defaultMessage} />
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
